import Controller from '@ember/controller';
import { service } from '@ember/service';
import type CurrentLocationService from 'garaje/services/current-location';

export default class CommunicationsMessageLogNewController extends Controller {
  @service declare currentLocation: CurrentLocationService;

  queryParams = ['from'];
  from: string = '';

  get locationId(): string {
    return this.currentLocation.location.id;
  }

  get locationName(): string {
    return this.currentLocation.location.name;
  }

  get showBackButton(): boolean {
    return this.from === 'message-log';
  }
}
